import MainAccordion from "../Accordion/MainAccordion";
import SurveyHistogramConfig from "../Trials/SurveyHistogramConfig";

const SurveyHistogramAccordion = ({ trialId, setMessage, setTypeOfMessage }) => {
  return (
    <MainAccordion
      title="Survey Histogram Configuration (App)"
      data={
        <SurveyHistogramConfig
          trialId={trialId}
          setMessage={setMessage}
          setTypeOfMessage={setTypeOfMessage}
        />
      }
    />
  );
};

export default SurveyHistogramAccordion;
